export default __webpack_public_path__ + "static/media/MOCKUP - MOTOROLA.cf71e6a9.png";